/* src/app/pto-policy/pto-policy-presenter/pto-policy-presenter.component.scss */
body#themeTag :host ::ng-deep .setup,
body#themeTag :host ::ng-deep .assignment {
  height: calc(100% - 75px);
}
/*# sourceMappingURL=pto-policy-presenter.component.css.map */
